import { h } from 'preact'

import imgix from '../../lib/imgix'

const SearchResultImage = ({ url, alt }) => {
  const blankSrc = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='

  // aspect ratio 16:9
  // max size = 550
  // min size = 240
  const sizes = []
  for (let i = 0; i < 6; i++) {
    sizes.push((i + 1) * 240)
  }
  const srcsets = sizes.map(size => `${imgix.buildSrc(url, { w: size, ar: '16:9', fit: 'crop' })} ${size}w`).join(', ')

  return (
    <img src={blankSrc} data-srcset={srcsets} alt={alt} class='img-fluid lazyload' />
  )
}

export default SearchResultImage
